import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer'
import { AuthProvider } from './context/AuthContext'
import PrivateRoute from './components/PrivateRoute'
import {
  BreadcrumbsProvider,
  BreadcrumbsConsumer,
  withBreadcrumb,
  Crumb,
} from './context/HeaderContext'
import ThemedSuspense from './components/ThemedSuspense'
import ErrorBoundary from './components/ErrorBoundary'

const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login/Login'))
const Logout = lazy(() => import('./pages/Logout'))
const LegalPolicy = lazy(() => import('./pages/Legal/LegalPolicy'))
const LegalConsent = lazy(() => import('./pages/Legal/LegalConsent'))
const OnBoardingIndex = lazy(() => import('./pages/OnBoardingPage/OnBoardingIndex'))
const LegalAgreement = lazy(() => import('./pages/Legal/LegalAggreement'))
const Thanks = lazy(() => import('./pages/Thanks/Thanks'))
const ResetPassword = lazy(() => import('./pages/Login/ResetPassword'))
const ResetPasswordMain = lazy(() => import('./pages/Login/ResetPasswordMain'))

function App() {
  return (
    <ErrorBoundary>
      <BreadcrumbsProvider>
        <Router>
          <AccessibleNavigationAnnouncer />
          <AuthProvider defaultRequireAuth={true}>
            <Suspense fallback={<ThemedSuspense />}>
              <Switch>
                <Route path="/logout" component={Logout} />
                <Route path="/legal_agreement" component={LegalAgreement} />
                <Route path="/legal_policy" component={LegalPolicy} />
                <Route path="/legal_consent" component={LegalConsent} />
                <Redirect exact from="/" to="/app" />
                <Route path="/login" component={Login} />
                <Route path="/thanks" component={Thanks} />
                <Route path="/reset-password/:token" component={ResetPassword} />
                <Route path="/reset-password" component={ResetPasswordMain} />
                <PrivateRoute path="/app" component={Layout} />
                <PrivateRoute path="/onboarding" component={OnBoardingIndex} />
              </Switch>
            </Suspense>
          </AuthProvider>
        </Router>
      </BreadcrumbsProvider>
    </ErrorBoundary>
  )
}

export default App
